import styled from 'styled-components';

export const CostTitlePurchaseStyled = styled.div<{}>`
  ${(props) => props.theme.fonts.mixins.boldHeader3};
  display: grid;
  justify-content: space-between;
  border-bottom: solid 3px ${(props) => props.theme.colors.black};
  gap: ${(props) => props.theme.spacing.spacing4};
  grid-template-columns: 1fr min-content;
`;

export const CostTitlePurchaseLabelStyled = styled.div<{ counterReset?: number; noCounter?: boolean }>`
  ${(props) => (props.counterReset ? `counter-reset: ordered-items-letters ${props.counterReset}` : '')};
  ${(props) =>
    props.noCounter
      ? ''
      : `
   display: grid;
   grid-template-columns: max-content;
   gap: ${props.theme.spacing.spacing4};
  `}
`;
